<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <!-- <hamburger
      id="hamburger-container"
      :is-active="!collapse"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />-->
    <!--面包屑导航-->
    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
    <div class="logo">
      <!-- <img v-if="!collapse" src="../assets/Deloitte-logo.svg" alt=""> -->
      <img src="../assets/logo.png" alt="" />
      <div class="logo-text">
        <div class="company-name"> 广西供应链服务集团-数字化物产云大数据平台 </div>
        <div class="company-name-w">GUANGXI SUPPLY CHAIN SERVICE GROUP CO.,LTD.</div>
      </div>
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <!--搜索-->
        <!-- <search id="header-search" class="right-menu-item" /> -->
        <!--<div class="btn-bell">-->
        <!--    <a title="操作手册" href="http://wiki.zjmichem.com/pages/viewpage.action?pageId=24051717" target="_blank"><i class="el-icon-question"></i></a>-->
        <!--</div>-->

        <span class="header-line" />
        <!-- 消息中心 -->
        <!-- <div class="btn-bell"> -->
        <!-- <el-tooltip effect="dark" :content="$t('message.query')" placement="bottom">
            <router-link to="/tabs">
              <i class="el-icon-question" />
            </router-link>
          </el-tooltip> -->
        <!-- <el-tooltip
            effect="dark"
            :content="message?$t('message.have')+`${message}`+$t('message.badgeNumber'):$t('message.messageCenter')"
            placement="bottom"
          >
            <router-link to="/tabs">
              <i class="el-icon-message-solid" />
            </router-link>
          </el-tooltip>
          <span v-if="message" class="btn-bell-badge" /> -->
        <!-- </div> -->
        <!-- <span class="header-line" /> -->
        <div v-if="userInfo.userInfo.isAuth === '2'" class="sirui-select">
          <!--公司-->
          <el-select v-model="company" value-key="personCompanyCode" @change="companyChange">
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.personCompanyName"
              :value="item"
            />
          </el-select>
          <!--部门-->
          <el-select
            v-model="department"
            value-key="personDepartmentCode"
            filterable
            popper-class="sirui-select"
            @change="departmentChange"
            style="margin-left: 10px; margin-right: 10px"
          >
            <el-option
              v-for="(item, index) in departmentList"
              :key="index"
              :label="item.personDepartmentName"
              :value="item"
            />
          </el-select>
        </div>
        <!-- 用户头像 -->
        <!--<div class="user-avator">-->
        <!-- <el-avatar :size="32" fit="fill" src="./static/img/img.jpg" /> -->
        <!-- <img src="static/img/img.jpg"> -->
        <!--</div>-->
        <!--国际化-->
        <!-- <div class="lang-select">
          <img class="lang-select-img" src="../assets/language.svg" alt="" />
          <lang-select class="set-language" />
        </div> -->
        <!-- 用户名下拉菜单 -->
        <div class="user-box">
          <img class="user-img" src="../assets/user-name.svg" alt="" />
          <el-dropdown class="user-name" trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ userInfo.userInfo.userName }}
              <i class="el-icon-caret-bottom" />
            </span>
            <el-dropdown-menu slot="dropdown" class="user-select">
              <el-dropdown-item command="updatePwd">
                <img src="../assets/edit-pw.svg" alt="" />
                {{ $t('confirm.updatePassword') }}
              </el-dropdown-item>
              <!--<el-dropdown-item>-->
              <!--  <img src="../assets/operation-manual.svg" alt="">-->
              <!--  <a title="操作手册" href="http://wiki.zjmichem.com/pages/viewpage.action?pageId=24051717" target="_blank">操作手册</a>-->
              <!--</el-dropdown-item>-->
              <el-dropdown-item command="loginout">
                <img src="../assets/log-out.svg" alt="" />
                {{ $t('confirm.loginout') }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('login.changePassword')"
      :visible.sync="dialogVisible"
      width="35%"
      :close-on-click-modal="false"
      :before-close="close"
      :show-close="showClose"
    >
      <el-form
        :model="updatePwd"
        :rules="updatePwdRule"
        ref="updatePwd"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('login.userAccount')" prop="userAccount">
          <el-input
            v-model="updatePwd.userAccount"
            :disabled="!showClose"
            size="medium"
            autocomplete="off"
            :placeholder="$t('login.userAccount')"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.beforePassword')" prop="beforePassword">
          <el-input
            v-model="updatePwd.beforePassword"
            :type="beforePasswordType"
            ref="beforePassword"
            autocomplete="new-password"
            :placeholder="$t('login.beforePassword')"
            size="medium"
            maxlength="32"
          ></el-input>
          <span class="show-pwd" @click="showUpPwd(1)">
            <svg-icon :icon-class="beforePasswordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item :label="$t('login.newPassword')" prop="newPassword">
          <el-input
            v-model="updatePwd.newPassword"
            :type="newPasswordType"
            size="medium"
            ref="newPassword"
            :placeholder="$t('login.newPassword')"
            maxlength="32"
            autocomplete="new-password"
          ></el-input>
          <span class="show-pwd" @click="showUpPwd(2)">
            <svg-icon :icon-class="newPasswordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item :label="$t('login.againNewPassword')" prop="againNewPassword">
          <el-input
            v-model="updatePwd.againNewPassword"
            :type="againNewPasswordType"
            ref="againNewPassword"
            size="medium"
            :placeholder="$t('login.againNewPassword')"
            maxlength="32"
            autocomplete="new-password"
          ></el-input>
          <span class="show-pwd" @click="showUpPwd(3)">
            <svg-icon :icon-class="againNewPasswordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
      </el-form>
      <div style="color: red; text-align: right">密码需包含英文和数字，长度最少8位</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('confirm.cancel') }}</el-button>
        <el-button type="primary" @click="subUpPwd('updatePwd')">{{
          $t('confirm.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/dataBase';
  import { mapState } from 'vuex';
  // import LangSelect from '@/components/LangSelect';
  // import Search from '@/components/HeaderSearch';
  import DICTAPI from '@/api/systemManage/dict';
  import BASE_API from '@/api/dataBase';
  // import VXETable from 'vxe-table';
  import bus from '../common/js/bus';
  import loading from '@/common/js/load.js'; //loading

  export default {
    components: {
      // LangSelect,
      // Search,
    },
    data() {
      // 修改密码校验规则
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('login.againNewPasswordEmpty')));
        } else if (value != this.updatePwd.newPassword) {
          callback(new Error(this.$t('login.againNewPasswordEmptys')));
        } else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('login.newPasswordEmpty')));
        } else if (value.length < 8) {
          callback(new Error(this.$t('login.newPasswordEmptyOne')));
        } else {
          // 修改密码校验规则为:字母和数字不区分大小学
          let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,32}$/;
          if (reg.test(value)) {
            callback();
          } else {
            callback(new Error(this.$t('login.newPasswordEmptyTwo')));
          }
        }
      };
      return {
        showClose: true,
        collapse: false,
        message: 2,
        company: null,
        companyList: [],
        department: null,
        departmentList: [],
        beforePasswordType: 'password',
        newPasswordType: 'password',
        againNewPasswordType: 'password',
        dialogVisible: false,
        updatePwd: {
          userAccount: '',
          beforePassword: '',
          newPassword: '',
          againNewPassword: '',
        },
        updatePwdRule: {
          userAccount: [
            {
              required: true,
              message: this.$t('login.userAccountEmpty'),
              trigger: 'blur',
            },
          ],
          beforePassword: [
            {
              required: true,
              message: this.$t('login.beforePasswordEmpty'),
              trigger: 'blur',
            },
          ],
          newPassword: [
            {
              required: true,
              validator: validatePass2,
              trigger: ['change', 'blur'],
            },
          ],
          againNewPassword: [
            {
              required: true,
              validator: validatePass,
              trigger: 'blur',
            },
          ],
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: function (state) {
          if (JSON.stringify(state.userInfo.userInfo) == '{}') {
            this.$store.commit('updateUserInfo');
          }
          return state.userInfo;
        },
        dictList: (state) => state.dict.dictList,
      }),
    },
    created() {
      this.$globalVar.refreshTokenFlag = 0; //初始化刷新token标识
      bus.$on('collapse', (msg) => {
        this.collapse = msg;
      });
    },
    mounted() {
      if (this.userInfo.userInfo.isAuth === '2') {
        this.getCompanyList();
        if (this.dictList.length == 0 || !this.dictList) {
          this.getDictList();
        }
      }
    },
    methods: {
      subUpPwd(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.updatePwd));
            data.beforePassword = this.Base64.encode(data.beforePassword);
            data.newPassword = this.Base64.encode(data.newPassword);
            loading.startLoading();
            this.$axios.post(API.UPDATE_PASSWORD, data).then((res) => {
              if (res.data.code == 0) {
                loading.endLoading();
                this.dialogVisible = false;
                // this.$refs[name].resetFields();
                //强制修改密码
                if (!this.showClose) {
                  this.showClose = true;
                  this.$store.commit('deleteUserInfo');
                  this.$router.push('/login');
                }
                this.$message({
                  message: res.data.msg,
                  type: 'success',
                });
              } else {
                // this.$refs[name].resetFields();
                this.$message.error(res.data.msg);
                this.updatePwd.newPassword = '';
              }
            });
          }
        });
        this.beforePasswordType = 'password';
        this.newPasswordType = 'password';
        this.againNewPasswordType = 'password';
        this.updatePwd = {
          // userAccount: "",
          beforePassword: '',
          newPassword: '',
          againNewPassword: '',
        };
        if (!this.showClose) {
          this.updatePwd.userAccount = this.userInfo.userInfo.account;
        }
      },
      showUpPwd(n) {
        if (n === 1) {
          this.beforePasswordType === 'password'
            ? (this.beforePasswordType = '')
            : (this.beforePasswordType = 'password');
          this.$nextTick(() => {
            this.$refs.beforePassword.focus();
          });
        } else if (n === 2) {
          this.newPasswordType === 'password'
            ? (this.newPasswordType = '')
            : (this.newPasswordType = 'password');
          this.$nextTick(() => {
            this.$refs.newPassword.focus();
          });
        } else {
          this.againNewPasswordType === 'password'
            ? (this.againNewPasswordType = '')
            : (this.againNewPasswordType = 'password');
          this.$nextTick(() => {
            this.$refs.againNewPassword.focus();
          });
        }
      },
      // 修改密码框关闭
      close() {
        if (this.showClose) {
          this.dialogVisible = false;
        } else {
          //强制修改密码
          this.$store.commit('deleteUserInfo');
          this.$router.push('/login');
        }
        this.$nextTick(() => {
          this.$refs['updatePwd'].resetFields();
        });
      },
      // 修改密码
      forgetPwd() {
        this.dialogVisible = true;
        this.$refs[name].resetFields();
      },
      // 获取当前登录人所在的公司
      getCompanyList() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            // 获取公司下拉
            this.companyList = res.data.data.personCompanyInfo || [];
            // 设置默认选中
            //刷新后不重新赋值
            if (!this.userInfo.userInfo.companyCode) {
              this.company = res.data.data.personCompanyInfo
                ? res.data.data.personCompanyInfo[0]
                : null;
            } else {
              this.company = {
                personCompanyCode: this.userInfo.userInfo.companyCode,
                personCompanyName: this.userInfo.userInfo.companyName,
              };
            }
            if (this.company) {
              // 获取部门下拉
              this.getDepartmentList(this.company.personCompanyCode, false);
            }
            if (!this.userInfo.userInfo.companyCode) {
              // 设置选中的公司信息
              this.userInfo.userInfo.companyCode = res.data.data.personCompanyInfo
                ? res.data.data.personCompanyInfo[0].personCompanyCode
                : null;
              this.userInfo.userInfo.companyName = res.data.data.personCompanyInfo
                ? res.data.data.personCompanyInfo[0].personCompanyName
                : null;
            }
            // 设置当前登录人的所在公司
            this.userInfo.userInfo.companyList = JSON.stringify(
              res.data.data.personCompanyInfo ? res.data.data.personCompanyInfo : []
            );
            this.userInfo.userInfo.allDepartmentList = res.data.data.personDepartmentInfo || [];
            this.$store.commit('saveUserInfo', this.userInfo.userInfo);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 公司切换
      companyChange(val) {
        this.department = null;
        this.company = val.personCompanyName;
        // 设置选中的公司信息
        this.userInfo.userInfo.companyCode = val.personCompanyCode;
        this.userInfo.userInfo.companyName = val.personCompanyName;
        this.$store.commit('saveUserInfo', this.userInfo.userInfo);

        this.getDepartmentList(val.personCompanyCode, true);
        this.toRefreshRoute();
      },
      // 获取当前登录人所在的部门
      getDepartmentList(code, refresh) {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: code,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
            // 设置选中的公司信息
            if (!this.userInfo.userInfo.departmentCode) {
              this.department = res.data.data.personDepartmentInfo[0];
              this.userInfo.userInfo.departmentCode =
                res.data.data.personDepartmentInfo[0].personDepartmentCode || null;
              this.userInfo.userInfo.departmentName =
                res.data.data.personDepartmentInfo[0].personDepartmentName || null;
              this.userInfo.userInfo.oaId = res.data.data.personDepartmentInfo[0].oaId || null;
              this.userInfo.userInfo.oaLoginId =
                res.data.data.personDepartmentInfo[0].oaLoginId || null;
              this.userInfo.userInfo.businessGroup =
                res.data.data.personDepartmentInfo[0].businessGroup || null;
            }
            if (refresh) {
              this.department = res.data.data.personDepartmentInfo[0];
              this.userInfo.userInfo.departmentCode =
                res.data.data.personDepartmentInfo[0].personDepartmentCode || null;
              this.userInfo.userInfo.departmentName =
                res.data.data.personDepartmentInfo[0].personDepartmentName || null;
              this.userInfo.userInfo.oaId = res.data.data.personDepartmentInfo[0].oaId || null;
              this.userInfo.userInfo.oaLoginId =
                res.data.data.personDepartmentInfo[0].oaLoginId || null;
              this.userInfo.userInfo.businessGroup =
                res.data.data.personDepartmentInfo[0].businessGroup || null;
            } else {
              this.department = {
                personDepartmentCode:
                  this.userInfo.userInfo.departmentCode ||
                  res.data.data.personDepartmentInfo[0].personDepartmentCode,
                personDepartmentName:
                  this.userInfo.userInfo.departmentName ||
                  res.data.data.personDepartmentInfo[0].personDepartmentName,
              };
            }
            this.$store.commit('saveUserInfo', this.userInfo.userInfo);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      departmentChange(val) {
        // 设置选中的公司信息
        this.department = val;
        this.userInfo.userInfo.departmentCode = val.personDepartmentCode;
        this.userInfo.userInfo.departmentName = val.personDepartmentName;
        this.userInfo.userInfo.departmentList = this.departmentList;
        this.userInfo.userInfo.oaId = val.oaId;
        this.$store.commit('saveUserInfo', this.userInfo.userInfo);
        this.toRefreshRoute();
      },
      // 切换公司或部门  跳转到首页
      toRefreshRoute() {
        this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
          const latestView = visitedViews.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView);
          } else {
            // You can set another route
            this.$router.push('/');
          }
        });
      },
      // 用户名下拉菜单选择事件
      handleCommand(command) {
        if (command === 'loginout') {
          this.$store.commit('deleteUserInfo');
          this.$router.push('/login');
        } else if (command === 'updatePwd') {
          this.dialogVisible = true;
          this.$nextTick(() => {
            this.$refs['updatePwd'].resetFields();
          });
        }
      },
      //获取数据字典
      getDictList() {
        // 字典集合
        this.$axios.post(DICTAPI.GET_ALL_DICT, { isDeleted: 0 }).then((res) => {
          if (res.data.code === 0) {
            this.$store.dispatch('dict/setDictList', res.data.data);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });

        // 商品单位
        this.$axios.post(BASE_API.GET_PRODUCT_UNIT_LIST, {}).then((res) => {
          if (res.data.code === 0) {
            let obj = [
              {
                dictType: 'basic_unit',
                dictName: '商品单位',
                dictList: res.data.data,
              },
            ];
            this.$store.dispatch('dict/setDictList', obj);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });

        //国家
        this.$axios.post(BASE_API.QUERY_COUNTRY, {}).then((res) => {
          if (res.data.code === 0) {
            let obj = [
              {
                dictType: 'person_national',
                dictName: '国家',
                dictList: res.data.data,
              },
            ];
            this.$store.dispatch('dict/setDictList', obj);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });

        //税率
        this.$axios.post(BASE_API.QUERY_TAX_RATE, {}).then((res) => {
          if (res.data.code === 0) {
            const list = res.data.data.map((it) => {
              it['value'] = it.taxCode || '99';
              it['label'] = it.taxName;
              return it;
            });
            let obj = [
              {
                dictType: 'tax_rate',
                dictName: '税率',
                dictList: list,
              },
            ];
            this.$store.dispatch('dict/setDictList', obj);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });

        //默认查询中国的省份
        this.$axios
          .post(BASE_API.QUERY_PROVICE + '?parentAreaNo=' + this.$globalVar.CHNCode, {})
          .then((res) => {
            if (res.data.code === 0) {
              let obj = [
                {
                  dictType: 'province',
                  dictName: '省',
                  dictList: res.data.data,
                },
              ];
              this.$store.dispatch('dict/setDictList', obj);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });

        //常用币种
        this.$baseRequest.getCurrency({ isEnabled: 1 }).then((res) => {
          if (res[0]) {
            let list = res.map((it) => {
              it['value'] = it.currencyCode;
              it['label'] = it.currencyName;
              return it;
            });
            let obj = [
              {
                dictType: 'all_currency',
                dictName: '全部币种',
                dictList: list,
              },
            ];
            this.$store.dispatch('dict/setDictList', obj);

            let list_often = list.filter((item) => item.commonFlag == 'Y');
            let obj_often = [
              {
                dictType: 'often_currency',
                dictName: '常用币种',
                dictList: list_often,
              },
            ];
            this.$store.dispatch('dict/setDictList', obj_often);
          }
        });
      },
      //强制修改密码
      upDataPwd() {
        // const password=Base64.decode(this.userInfo.userInfo.password)
        // console.log(Base64.decode(this.userInfo.userInfo.password))

        // console.log(this.userInfo.userInfo.inoutFlag)
        // console.log(Base64.decode(this.userInfo.userInfo.password)==this.userInfo.userInfo.personNo)
        if (
          this.userInfo.userInfo.inoutFlag == 'I' &&
          this.Base64.decode(this.userInfo.userInfo.password) == this.userInfo.userInfo.personNo
        ) {
          this.updatePwd.userAccount = this.userInfo.userInfo.account;
          this.showClose = false;
          this.dialogVisible = true;
        }
      },
    },
  };
</script>
<style lang="scss">
  .user-select {
    // background-color: #000000;
    padding: 0;
    border-radius: 6px;
    .el-dropdown-menu__item {
      min-width: 74px;
      line-height: 30px;
      font-size: 12px;
      border-radius: 6px;
      color: #606266;
      a {
        color: #606266;
      }
      img {
        width: 13px;
        height: 13px;
        padding-right: 8px;
        vertical-align: middle;
      }
    }

    .popper__arrow::after {
      border-bottom-color: #000000 !important;
    }
  }
  .sirui-select {
    .popper__arrow::after {
      border-bottom-color: #000000 !important;
    }
  }
</style>
<style lang="scss" scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 2px;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px;
    font-size: 22px;
    .logo {
      display: flex;
      padding-left: 12px;
      color: #ffffff;
      img {
        vertical-align: middle;
        margin-top: 2px;
        width: 58px;
        height: 46px;
      }
      .logo-text {
        padding-left: 2px;
      }
      .company-name {
        text-indent: 0px;
        line-height: 30px;
        font-size: 16px;
      }
      .company-name-w {
        text-indent: 0px;
        line-height: 20px;
        font-size: 12px;
      }
      .el-image {
        width: 200px;
        height: 30px;
        padding: 10px 0;
      }
    }
    .breadcrumb-container {
      float: left;
    }
    .header-line {
      display: inline-block;
      height: 20px;
    }
    .lang-select {
      width: 90px;
      height: 36px;
      line-height: 36px;
      padding: 0 30px;
      text-align: center;
      .lang-select-img {
        vertical-align: sub;
        width: 20px;
        height: 20px;
      }
      ::v-deep .el-dropdown-link {
        font-size: 12px;
      }
    }
    .right-menu-item {
      display: inline-block;
      height: 100%;
      line-height: 50px;
      font-size: 18px;
      color: #aaa;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
  }
  .collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 50px;
  }
  .header-right {
    float: right;
    padding-right: 30px;
  }
  .header-user-con {
    display: flex;
    height: 50px;
    align-items: center;
  }
  .btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
  }
  .btn-bell i {
    color: #66b1ff;
  }
  .el-icon-question {
    margin-right: 20px;
  }
  .btn-bell {
    margin: 0px 28px;
  }
  .btn-bell,
  .btn-fullscreen {
    position: relative;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
  }

  .btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
  }
  .btn-bell .el-icon-bell {
    color: #aaa;
  }
  .user-box {
    height: 36px;
    line-height: 36px;
    .user-img {
      width: 16px;
      height: 16px;
    }
  }
  .user-name {
    margin-left: 8px;
  }
  .user-avator {
    height: 32px;
    margin-left: 20px;
  }
  .user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .el-dropdown-link {
    color: #ffffff;
    cursor: pointer;
  }
  .el-dropdown-menu__item {
    text-align: center;
  }
  .sirui-select {
    ::v-deep .el-select .el-input .el-select__caret {
      color: #ffffff;
    }
    ::v-deep .el-icon-arrow-up:before {
      content: '\E790';
    }
  }
</style>
